<script>
  import {BeginnerMenu} from "@util/constant.js"
  import LargeMenuItem from "./LargeMenuItem.svelte"

</script>


<LargeMenuItem Menu={BeginnerMenu} ColumnNumber={2} />
